<div class="col-xl">
    <div class="card mb-4">
        <div class="card-header">
            <div class="row">
                <div class="col-lg-12">
                    <button class="btn btn-primary" (click)="showCreateForm()">
                        <i class="ti ti-plus"></i> Nueva Configuración
                    </button>
                </div>
            </div>

        </div>
        <div class="card-body">
            <div *ngIf="loading" class="text-center">
                <div class="spinner-border" role="status">
                    <span class="visually-hidden">Cargando...</span>
                </div>
            </div>

            <div *ngIf="!loading && configurations.length === 0" class="text-center py-4">
                <p class="text-muted">No hay configuraciones de notificaciones</p>
            </div>
            <div *ngIf="!loading && configurations.length > 0">
                <ag-grid-angular class="ag-theme-alpine" style="width: 100%; height: 60vh;" [rowData]="configurations"
                    [columnDefs]="columnDefs" [defaultColDef]="defaultColDef" [gridOptions]="gridOptions"
                    (gridReady)="onGridReady($event)">
                </ag-grid-angular>
            </div>

        </div>
    </div>
</div>

<!-- Modal Form -->
<div class="modal fade" id="configModal" tabindex="-1" aria-labelledby="configModalLabel" aria-hidden="true"
    *ngIf="showForm">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="configModalLabel">{{ editingId ? 'Editar' : 'Nueva' }} Configuración</h5>
                <button type="button" class="btn-close" (click)="cancelForm()" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <form [formGroup]="configForm" (ngSubmit)="onSubmit()">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="mb-3">
                                <label class="form-label">Nombre *</label>
                                <input type="text" class="form-control" formControlName="name"
                                    placeholder="service_created, maintenance_created, etc.">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="mb-3">
                                <label class="form-label">Título *</label>
                                <input type="text" class="form-control" formControlName="title"
                                    placeholder="Título de la notificación">
                            </div>
                        </div>
                    </div>

                    <div class="mb-3">
                        <label class="form-label">Plantilla de Mensaje *</label>
                        <textarea class="form-control" rows="3" formControlName="message_template"
                            placeholder="Mensaje con variables: {service_id}, {user_id}, etc."></textarea>
                        <small class="form-text text-muted">
                            Variables disponibles: {{ '{' }}service_id{{ '}' }}, {{ '{'
                            }}maintenance_id{{ '}' }}, {{ '{' }}user_id{{ '}' }}, {{ '{' }}created_at{{
                            '}' }}, {{ '{' }}old_status{{ '}' }}, {{ '{' }}new_status{{ '}' }}, {{ '{'
                            }}changed_at{{ '}' }}
                        </small>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <div class="mb-3">
                                <label class="form-label">Roles Objetivo</label>
                                <select class="form-control" formControlName="target_roles" multiple>
                                    <option *ngFor="let role of roles" [value]="role.id">{{ role.name }}
                                    </option>
                                </select>
                                <small class="form-text text-muted">Mantén Ctrl presionado para
                                    seleccionar múltiples roles</small>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="mb-3">
                                <label class="form-label">Opciones</label>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" formControlName="push_enabled"
                                        id="pushEnabled">
                                    <label class="form-check-label" for="pushEnabled">
                                        Notificaciones Push habilitadas
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" formControlName="whatsapp_enabled"
                                        id="whatsappEnabled">
                                    <label class="form-check-label" for="whatsappEnabled">
                                        Notificaciones WhatsApp habilitadas
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" formControlName="is_active"
                                        id="isActive">
                                    <label class="form-check-label" for="isActive">
                                        Configuración activa
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- WhatsApp Group Number Field -->
                    <div class="row" *ngIf="configForm.get('whatsapp_enabled')?.value">
                        <div class="col-md-12">
                            <div class="mb-3">
                                <label class="form-label">Número de Grupo WhatsApp</label>
                                <input type="text" class="form-control" formControlName="whatsapp_group_number"
                                    placeholder="Ejemplo: 573001234567-1234567890@g.us">
                                <small class="form-text text-muted">
                                    Ingresa el número del grupo de WhatsApp al cual se enviarán las notificaciones
                                </small>
                            </div>
                        </div>
                    </div>

                    <!-- Status Selection Fields -->
                    <div class="row" *ngIf="configForm.get('name')?.value?.includes('status_changed')">
                        <div class="col-md-6">
                            <div class="mb-3">
                                <label class="form-label">Estados de Servicio</label>
                                <select class="form-control" formControlName="service_statuses" multiple>
                                    <option *ngFor="let status of serviceStatuses" [value]="status.id">{{ status.name }}
                                    </option>
                                </select>
                                <small class="form-text text-muted">Selecciona los estados de servicio que activarán esta notificación</small>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="mb-3">
                                <label class="form-label">Estados de Mantenimiento</label>
                                <select class="form-control" formControlName="maintenance_statuses" multiple>
                                    <option *ngFor="let status of maintenanceStatuses" [value]="status.id">{{ status.name }}
                                    </option>
                                </select>
                                <small class="form-text text-muted">Selecciona los estados de mantenimiento que activarán esta notificación</small>
                            </div>
                        </div>
                    </div>

                    <div class="mb-3">
                        <label class="form-label">Plantillas Predefinidas</label>
                        <div class="btn-group" role="group">
                            <button type="button" class="btn btn-outline-secondary btn-sm"
                                *ngFor="let template of templates" (click)="useTemplate(template)">
                                {{ template.title }}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="cancelForm()">Cancelar</button>
                <button type="button" class="btn btn-primary" (click)="onSubmit()" [disabled]="!configForm.valid">
                    {{ editingId ? 'Actualizar' : 'Crear' }}
                </button>
            </div>
        </div>
    </div>
</div>